// 납부서 알림톡 템플릿 (퍼플북 등록 템플릿을 화면 재현용으로 옮겨 적은 것).
// 실제 발송 본문은 서버가 만들고, 여기서는 발송 이력(templateId + variables)으로 근사 재현만 한다.

export interface KakaoTemplate {
  // 알림톡 상단 회색 강조표기
  emphasis: string;
  // 굵은 제목
  title: string;
  // 본문 (#{BNM} 등 치환 변수 포함)
  body: string;
  // 하단 회색 부가정보
  footer?: string;
}

export const KAKAO_TEMPLATES: Record<string, KakaoTemplate> = {
  // 원천세 납부 안내 (일반)
  KA01TP260825033106972lt4TMBsej6G: {
    emphasis: "원천세 신고가 완료되었습니다",
    title: "원천세 납부 안내",
    body: `안녕하세요 #{BNM} 대표님.
#{YM} 귀속분 급여의 원천세 신고가 완료되어 안내 드립니다.
이번달 급여에 대한 납부서는 #{CNT} 건 입니다.

▶ 납부 기한 : #{PMD}
▶ 주의 사항 : 납부 기한이 지나면 가산세가 부과될 수 있으니, 잊지 마시고 기한 내에 꼭 납부해 주시기 바랍니다.
(부득이 납부기한 경과시 별도 연락 부탁드립니다)`,
    footer: "납부서는 세무특공대에서 확인하실 수 있습니다."
  },

  // 원천세 신고 완료 — 차기이월 환급세액 존재
  KA01TP260825033433832OT8vydIjpE5: {
    emphasis: "원천세 신고가 완료되었습니다",
    title: "원천세 신고 완료",
    body: `안녕하세요 #{BNM} 대표님.
#{YM} 귀속분 급여의 원천세 신고가 완료되어 안내 드립니다.

이번달 급여에 대한 세액 정산 결과, 차기이월 환급세액이 존재하여 이번달 납부하실 세액은 없습니다.

잔여 차기이월 환급세액은 신고접수증 확인 부탁드립니다.`,
    footer: "납부서는 세무특공대에서 확인하실 수 있습니다."
  },

  // 원천세 신고 완료 — 납부세액 없음
  KA01TP260901021143790z2XvQnk76CM: {
    emphasis: "원천세 신고가 완료되었습니다",
    title: "원천세 신고 완료",
    body: `안녕하세요 #{BNM} 대표님.
#{YM} 귀속분 급여의 원천세 신고가 완료되어 안내 드립니다.

이번달 급여에 대한 세액 정산 결과 납부하실 세액은 없습니다.

감사합니다.`
  },

  // 원천세 납부 안내 — 수정사항 반영 납부서 재발급
  KA01TP260901021610955un9s4Ts7tvy: {
    emphasis: "원천세 신고가 완료되었습니다",
    title: "원천세 납부 안내",
    body: `안녕하세요 #{BNM} 대표님.
#{YM} 귀속분 급여의 원천세 수정사항을 반영한 납부서가 재발급 되었습니다.

기존 납부서가 아닌 새롭게 발급된 납부서 기준으로 납부 부탁드립니다.
이번달 급여에 대한 납부서는 #{CNT} 건 입니다.

▶ 납부 기한 : #{PMD}
▶ 주의 사항 : 납부 기한이 지나면 가산세가 부과될 수 있으니, 잊지 마시고 기한 내에 꼭 납부해 주시기 바랍니다.
(부득이 납부기한 경과시 별도 연락 부탁드립니다)`,
    footer: "납부서는 세무특공대에서 확인하실 수 있습니다."
  },

  // 원천세 신고 완료 — 납부세액 없음 (재안내)
  KA01TP260901022539482NQsyCbPn5sm: {
    emphasis: "원천세 신고가 완료되었습니다",
    title: "원천세 신고 완료",
    body: `안녕하세요 #{BNM} 대표님.
#{YM} 귀속분 급여의 원천세 신고가 완료되어 재안내 드립니다.

이번달 급여에 대한 세액 정산 결과 납부하실 세액은 없습니다.

감사합니다.`
  }
};

// 템플릿 본문의 #{XXX} 를 실제 변수 값으로 치환. 값이 없으면 원문 유지.
export function fillTemplate(
  text: string,
  variables: Record<string, string>
): string {
  return text.replace(/#\{[A-Za-z]+\}/g, (m) => variables[m] ?? m);
}
